import { NoddiSelect } from 'noddi-ui-web';
import { LABEL_PRINTERS, LabelPrinterModel, useLabelPrinterStore } from './labelPrinter';

const OPTIONS = Object.values(LabelPrinterModel).map((model) => {
  const { name, widthMm, heightMm } = LABEL_PRINTERS[model];
  return { value: model, label: `${name} · ${widthMm} × ${heightMm} mm` };
});

/** Picks the label printer connected to this computer. */
export const LabelPrinterSelect = () => {
  const { model, setModel } = useLabelPrinterStore();
  return (
    <NoddiSelect
      label='Label printer on this computer'
      options={OPTIONS}
      value={model}
      // Choosing the selected option again clears it; this computer always has a printer.
      onChange={(value) => value && setModel(value)}
      clearable={false}
      searchable={false}
    />
  );
};
